import React from 'react';
import { Box, Button, Heading, Link, Text, VStack } from '@chakra-ui/react';
import { FaEnvelope } from 'react-icons/fa';

const Contact = () => {
  return (
    <Box
      minH="calc(100vh - var(--nav-h))"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={6}
      py={12}
    >
      <VStack gap={6} maxW="720px" textAlign="center">
        <Heading as="h1" size="2xl" color="gray.700">
          Contact Us
        </Heading>

        <Button
          as={Link}
          href="mailto:eli@dcfteacher.com"
          colorPalette="blue"
          size="lg"
          textDecoration="none"
          _hover={{ textDecoration: 'none' }}
        >
          <FaEnvelope />
          Email eli@dcfteacher.com
        </Button>

        <Text fontSize={{ base: 'lg', md: 'xl' }} color="gray.600" lineHeight="1.8">
          Email me at <b>eli@dcfteacher.com</b> with a question, bug report, feature request, or just to say hi.
        </Text>

        <Text fontSize={{ base: 'lg', md: 'xl' }} color="gray.600" lineHeight="1.8">
          I read every email and will respond personally.
        </Text>
        
      </VStack>
    </Box>
  );
};

export default Contact;
